import { GQLAllSchemeUrlsQuery } from "@src/graphql.apollo.generated";

export const checkIfLandingPageExists = (url: string, allSchemeUrls: GQLAllSchemeUrlsQuery["allSchemeUrls"]) =>
    allSchemeUrls.some((schemeUrl: any) => schemeUrl.url === url);
